import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { Service } from '../../../services';
import { Router } from '@angular/router';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { Alert } from 'selenium-webdriver';
@Component({
  selector: 'app-permission-assignment',
  templateUrl: './permission-assignment.component.html',
  styleUrls: ['./permission-assignment.component.sass']
})
export class PermissionAssignmentComponent implements OnInit {
  @Input() tunnel;
  @Input() name;
  @Input() lastName;
  @Input() email;
  @Input() phoneNumber;
  @Input() idRole;
  @Input() role;
  @Input() acount;
  @Input() token;
  @Output() nextStep = new EventEmitter<number>();
  public moduleData:any;
  public idUser;
  public idUserAPP;
  public dataSend:any=[];
  public dataJson;
  public typeOfAction;
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService,private router:Router) { }

  ngOnInit() {
    if(this.tunnel!=undefined && this.tunnel!="" && this.tunnel!=null){
      this.typeOfAction='edit';
      let idRolesUsuario=this.tunnel.id;
      this.name=this.tunnel.name;
      this.role=this.tunnel.role;
      this.lastName=this.tunnel.lastname;
      this.email=this.tunnel.email;
      this.phoneNumber=this.tunnel.phone;
      this.loadingScreenService.startLoading();
      this.services.idUserRoleList(idRolesUsuario).subscribe(data =>{
        this.loadingScreenService.stopLoading();
        this.moduleData = data;
      });
    }
    else{
      this.typeOfAction='add';
      this.idUser=parseInt(sessionStorage.getItem("idUser"));
      this.idUserAPP=sessionStorage.getItem("idUserAPP");
      this.moduleData = JSON.parse(atob(sessionStorage.getItem("moduleData")));
      this.loadingScreenService.startLoading();
      this.services.idRoleList(this.idRole).subscribe(data =>{
        this.loadingScreenService.stopLoading();
        this.moduleData = data;
      });
    }
  }
  continue(){
    this.dataSend=[this.moduleData.length];
    this.dataJson='[';
    let status;
    for(var i=0;i<this.moduleData.length;i++){
      this.dataSend[i]=this.moduleData[i].status;
      this.dataJson=this.dataJson+'{'
      if(this.typeOfAction=='add'){
        this.dataJson=this.dataJson+'"id":'+this.moduleData[i].id_role_module+',';
      }
      else{
        this.dataJson=this.dataJson+'"id":'+this.moduleData[i].id_user_role_module+',';
      }
      if(this.moduleData[i].status==true){
        status=1
      }
      else{
        status=0
      }
      this.dataJson=this.dataJson+'"status":'+status;
      if(i==this.moduleData.length-1){
        this.dataJson=this.dataJson+'}';
      }
      else{
        this.dataJson=this.dataJson+'},';
      }
    }
    this.dataJson=this.dataJson+']';
    if(this.typeOfAction=='add'){
      this.loadingScreenService.startLoading();
      this.services.createUser(this.token,this.idUserAPP,this.idUser,this.idRole,this.name,this.lastName,this.email,this.phoneNumber,this.acount,this.dataJson,this.role).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if(data.hasError==false){
          this.nextStep.emit(3);
          this.global.notif(data.errorDesc);
        }
        else{
          this.global.notif(data.errorDesc);
        }
      });
    }
    else{
      this.loadingScreenService.startLoading();
      this.services.updateRoles(this.dataJson).subscribe(data => {
        this.loadingScreenService.stopLoading();
        if(data.hasError==false){
          //this.router.navigate(['usersandpermissions']);
          this.global.notif(data.errorDesc);
        }
        else{
          this.global.notif(data.errorDesc);
        }
      });
    }
  }
  updCheck(index,value){
    this.moduleData[index].status=value;
  }
  back(){
    if(this.typeOfAction=='add'){
      this.nextStep.emit(1);
    }
    else{
      this.router.navigate(['usersandpermissions']);
    }
  }
  isOdd(num) { 
    return num % 2;
  }
}